import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { format, isValid } from 'date-fns';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 8,
  },
  title: {
    fontWeight: 600,
    color: '#117CA8',
  },
  content: {
    paddingTop: 8,
    maxHeight: '60vh',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#BFE3F3 transparent',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#BFE3F3',
      borderRadius: 4,
    },
  },
}));

const ExtendDayDialog = (props) => {
  const { open, onClose, date, tasks, renderItem } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const scheduleDate = date ? new Date(date) : null;
  const title = scheduleDate && isValid(scheduleDate) ? format(scheduleDate, 'EEEE, dd MMM yyyy') : '';

  return (
    <Dialog open={open} onClose={onClose} scroll="paper" maxWidth="sm" fullWidth>
      <DialogTitle disableTypography className={clsx(classes.titleRow)}>
        <Typography variant="h6" className={clsx(classes.title, 'cursor-default')}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>
      <DialogContent className={clsx(classes.content)} dividers>
        {(tasks || []).map((task) => renderItem(task))}
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={onClose}>
          {t('BUTTON_CANCEL')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtendDayDialog;
